import { render, staticRenderFns } from "./AulasGraphic.vue?vue&type=template&id=79b0e482&scoped=true"
import script from "./AulasGraphic.vue?vue&type=script&lang=js"
export * from "./AulasGraphic.vue?vue&type=script&lang=js"
import style0 from "./AulasGraphic.vue?vue&type=style&index=0&id=79b0e482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b0e482",
  null
  
)

export default component.exports